import { createStyledClone } from '@/services/print/svghelpers';

export default (popGrowthModel, options) => {
    // Get options from the passed template, but popGrowth does not actually return the template.
    const { colour } = options;
    const formattedGrowth = popGrowthModel.formatWithUnits(popGrowthModel.growth);
    const growthValue = {
        val: {
            align: 'right',
            font: { weight: 'bold', colour, size: 'xl' },
            text: `${formattedGrowth}`
        },
        label: {
            mt: -3,
            align: 'right',
            font: { weight: 'normal', colour, size: 'sm' },
            text: 'in this LGA'
        }
    };
    const growthCompareValue = {
        mt: 5,
        val: {
            align: 'right',
            font: { weight: 'normal', size: 'base' },
            text: `${popGrowthModel.formatWithUnits(popGrowthModel.comparisonGrowth)}`
        },
        label: {
            align: 'right',
            font: { weight: 'normal', size: 'sm' },
            text: 'in Alberta'
        }
    };

    // Orders the growth Value labels, based on which has more growth
    const growthValues = () => {
        let val1 = growthValue;
        let val2 = growthCompareValue;
        if (popGrowthModel.comparisonGrowth > popGrowthModel.growth) {
            val1 = growthCompareValue;
            val2 = growthValue;
        }
        return {
            val1,
            val2: {
                mt: 5,
                ...val2
            }
        };
    };

    // console.log('popGrowthModel chart for ', popGrowthModel, colour);
    const populationGrowth = {
        h: 'h-4',
        totals: {
            // h: 'h-1-1/2',
            popTotalTitle: {
                text: popGrowthModel.title,
                font: { weight: 'bold', size: 'base', colour: 'print.strong' },
                superscript: `${popGrowthModel.reference.index}`,
                // h: 'h-0-1/4'
            },
            popTotals: {
                mt: 5,
                lga: {
                    w: 'w-3',
                    value: {
                        font: { weight: 'bold', colour, size: 'xl' },
                        text: `${popGrowthModel.formatValue(popGrowthModel.value)}`
                    },
                    label: {
                        text: `in ${popGrowthModel.valueLabelFull}`,
                        font: { weight: 'normal', colour, size: 'sm' },
                        w: 'w-4'
                        // y: 'h-0-7/16'
                    }
                },
                compareValue: {
                    display: 'inline',
                    w: 'w-1',
                    value: {
                        font: { weight: 'normal', size: 'base' },
                        align: 'right',
                        text: `${popGrowthModel.formatValue(popGrowthModel.comparisonValue)}`
                    },
                    label: {
                        text: 'in Alberta',
                        align: 'right',
                        font: { weight: 'normal', size: 'sm' },
                    }
                }
            }
        },
        growth: {
            // h: 'h-2-1/2',
            mt: 10,
            popGrowthTitle: {
                text: popGrowthModel.growthLabel,
                font: { weight: 'bold', size: 'base', colour: 'print.strong' },
                superscript: `${popGrowthModel.reference.index}`
            },
            popGrowth: {
                chart: {
                    h: 'h-1-1/4',
                    w: 'w-3',
                    // preserveAspectRatio: false,
                    styles: {
                        selectors: {
                            text: {
                                font: { size: 'base' }
                            }
                        }
                    },
                    svg: createStyledClone({
                        selector: `#${popGrowthModel.id} svg:not(.content-placeholder):not(.svg-inline)`
                    })
                },
                labels: {
                    display: 'inline',
                    w: 'w-1',
                    ...growthValues()
                }
            },
            description: {
                mt: 8,
                text: `${popGrowthModel.valueLabel} has seen ${popGrowthModel.comparisonGrowth > popGrowthModel.growth ? 'slower' : 'faster'} growth in population than the province as a whole.`
            }
        }
    };
    return populationGrowth;
};
